import { createSlice } from '@reduxjs/toolkit';
import { DocumentType } from '@cp/pages/CaseDetails/components/AllDocumentsV2/types';

type DocumentSliceType = {
  documents: Documents | null;
  isDocumentsLoading: boolean;
};

export type Documents = {
  documentDetails?: {
    [key: string]: DocumentType;
  };
};
const initialState: DocumentSliceType = {
  documents: null,
  isDocumentsLoading: false
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    setIsDocumentsLoading: (state, action) => {
      state.isDocumentsLoading = action.payload;
    }
  }
});

export default documentsSlice.reducer;

export const { setDocuments, setIsDocumentsLoading } = documentsSlice.actions;
